export const UI_PREFIX_ANDROID = 'android_abtest';
export const UI_PREFIX_IOS = 'ios_abtest';
export const UI_PREFIX_WEBVIEW = 'webview';
export const WEB = 'web';
export const ANDROID = 'android';
export const IOS = 'ios';
